module.exports = __webpack_public_path__ + "static/media/chevron-double-right.be76b329.svg";